module.exports = __webpack_public_path__ + "./fonts/AntDesign.ttf";